var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAldoraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 233",
    style: {
      enableBackground: "new 0 0 504 233"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#115E67;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,232.1H0l35.9-54.1h10.4l35.2,54.1H71.2L62.4,219H18.8L9.9,232.1z M44.1,190.5l-3.3-5.3l-3.3,5.3 l-13.8,20.3h34.1L44.1,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,232.1v-54.1h9.2v45.5h46.9v8.6H94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.3,232.1h-38.7v-54.1h38.6c16,0,25,5.1,28.8,13.6c1.6,3.7,2.4,8,2.4,12.9c0,4.9-0.8,9.4-2.4,13.2 C228,226.8,218.9,232.1,203.3,232.1z M224.9,205.1c0-3.7-0.6-6.8-1.7-9.4c-3-6.2-9.6-9.5-21.2-9.5h-28.3V224h27.5 c12.3,0,19-3.3,21.9-9.4C224.4,211.9,224.9,208.7,224.9,205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.6,186c5.9,5.1,8.2,11.4,8.2,19c0,7.7-2.7,14.3-8,18.8c-6.8,6.4-17.9,9.2-31.6,9.2 c-12.9,0-23.1-3-30.1-8.6c-6-4.6-9.4-11.1-9.4-19.5c0-7.2,2.4-13.4,8.2-18.4c7.5-6.9,17.5-9.6,31.4-9.6 C300.2,176.9,310.4,179.7,317.6,186z M310.9,217.5c3.9-3.3,5.5-7.8,5.5-12.5c0-4.8-1.6-9.6-5.7-12.9c-5.4-4.4-13-6.7-24.6-6.7 c-10.9,0-19.5,2.5-24.3,6.8c-3.9,3.3-5.8,7.8-5.8,12.8c0,5.7,2.2,10.2,7.1,13.6c5.7,4.2,13.2,6,23.1,6 C297.2,224.6,305.3,222.6,310.9,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.3,201.7c-1.9,3.1-5.7,6-11.2,6.6l20.1,23.8h-10.9l-18.9-22.6h-32.6v22.6h-9.2v-54.1h43.9 c9.3,0,15.2,2.6,18.2,6.4c1.7,2.3,2.6,5.1,2.6,8.8C406.3,196.6,405.7,199.5,404.3,201.7z M396,189.9c-1.7-2.3-4.8-3.5-9.4-3.5 h-35.8v14.8h36.1c5.2,0,8-1.1,9.3-3.3c0.8-1.3,1-2.7,1-4C397.2,192.4,396.9,191.1,396,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.4,232.1h-9.9l35.9-54.1h10.4l35.2,54.1h-10.2L485,219h-43.6L432.4,232.1z M466.6,190.5l-3.3-5.3l-3.3,5.3 l-13.8,20.3h34.1L466.6,190.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.697,
    y1: 214.631,
    x2: 384.301,
    y2: 214.631,
    gradientTransform: "matrix(1 0 0 1 0 -142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5024,
    style: {
      stopColor: "#4A773C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    style: {
      stopColor: "#63953A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70A539"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,0v8.4l44.4,23.1V85L252,73.1v7.7l44.4,11.9v52.6h7.4V94.7l38.1,10.2v40.4h7.4v-38.4l27.5,7.3v31.1h7.4 V68.8L252,0z M342,97.2L303.8,87V35.3L342,55.2V97.2z M376.9,106.5l-27.5-7.3V59l27.5,14.3V106.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.701,
    y1: 214.6315,
    x2: 252,
    y2: 214.6315,
    gradientTransform: "matrix(1 0 0 1 0 -142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    style: {
      stopColor: "#115E67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    style: {
      stopColor: "#194E59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9986,
    style: {
      stopColor: "#253746"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.6,145.3V116l102.5-27.4v56.6H252V0L119.7,68.8v76.5L134.6,145.3L134.6,145.3z M237.1,73.3l-102.5,27.4 V77.8l102.5-53.3L237.1,73.3L237.1,73.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAldoraLogo);
export default __webpack_public_path__ + "static/media/aldora_logo.245bfa231fc0735d1a3850656ace915d.svg";
export { ForwardRef as ReactComponent };